<div class="pagination-btn">
  <div class="navigation-items">
    <ex-button
      type="secondary"
      variant="raised"
      size="x-large"
      icon="arrow-left-fill"
      (click)="onPageClick(currentPage - 1)"
      [disabled]="currentPage === 1"
    >
      {{ 'button.prev' | translate }}
    </ex-button>
    <ng-container *ngFor="let pageIndex of listOfPage; let i = index">
      <div
        class="align-self-center item active"
        [ngClass]="{ active: currentPage === pageIndex }"
        *ngIf="i === 0"
        (click)="onPageClick(pageIndex)"
      >
        <a class="">{{ pageIndex }}</a>
      </div>
      <div
        class="align-self-center item"
        *ngIf="currentPage >= maxNbPagesConsecutive && i === 3 && i < nbPages && nbPages > maxNbPagesShow"
      >
        <a class="">...</a>
      </div>
      <div
        class="align-self-center item"
        [ngClass]="{ active: currentPage === pageIndex }"
        *ngIf="
          (showWhenInFirstPages(pageIndex) || showWhenInLastPages(pageIndex) || showNextPrevPage(pageIndex)) && notShowFirstLastPage(i)
        "
        (click)="onPageClick(pageIndex)"
      >
        <a class="">{{ pageIndex }}</a>
      </div>
      <div
        class="align-self-center item"
        *ngIf="currentPage <= nbPages - maxNbPagesConsecutive + 1 && i === nbPages - 4 && nbPages > maxNbPagesShow"
      >
        <a class="">...</a>
      </div>
      <div
        class="align-self-center item"
        [ngClass]="{ active: currentPage === nbPages }"
        *ngIf="i === nbPages - 1"
        (click)="onPageClick(pageIndex)"
      >
        <a class="">{{ nbPages }}</a>
      </div>
    </ng-container>
    <ex-button
      type="secondary"
      variant="raised"
      size="x-large"
      icon="arrow-right-fill"
      iconPosition="right"
      (click)="onPageClick(currentPage + 1)"
      [disabled]="currentPage === nbPages"
    >
      {{ 'button.next' | translate }}
    </ex-button>
  </div>
</div>
